export default __webpack_public_path__ + "static/media/Helm of the Valiant.5a568217.jpg";